import Component from './message_queue_dialog.vue'
export default Component
